/**
 * Email Utility Functions
 * 
 * Handles email normalization for authentication flows
 */

/**
 * Normalizes an email address to lowercase and trims whitespace
 * 
 * AWS Cognito treats email-based usernames as case-sensitive.
 * This function ensures consistent email format across all auth operations.
 * 
 * @param email - The email address to normalize
 * @returns The normalized email (lowercase, trimmed)
 * 
 * @example
 * normalizeEmail('John@Example.com')  // Returns: 'john@example.com'
 * normalizeEmail('  TEST@test.com  ') // Returns: 'test@test.com'
 */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/**
 * Validates email format (basic check)
 * 
 * @param email - The email address to validate
 * @returns True if email format is valid
 * 
 * @example
 * isValidEmail('test@example.com')  // Returns: true
 * isValidEmail('invalid-email')     // Returns: false
 */
export function isValidEmail(email: string): boolean {
  return /\S+@\S+\.\S+/.test(email);
}
